import React from "react";
import { useApp } from "../context/AppContext";
import { Button } from "../components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Landmark } from "lucide-react";
import EmailAuth from "../components/EmailAuth";

export default function Login() {
  const { t, lang, setLang, theme, setTheme } = useApp();

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="flex flex-col justify-center px-8 sm:px-16 lg:px-24 py-12">
        <div className="flex items-center gap-3 mb-10">
          <div className="h-10 w-10 rounded-lg bg-primary flex items-center justify-center">
            <Landmark className="h-6 w-6 text-primary-foreground" />
          </div>
          <div>
            <div className="font-heading font-bold text-lg">{t("app.name")}</div>
            <div className="text-xs uppercase tracking-wider text-muted-foreground">{t("app.tagline")}</div>
          </div>
        </div>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight mb-4" data-testid="login-title">
          {t("login.title")}
        </h1>
        <p className="text-muted-foreground text-sm sm:text-base leading-relaxed mb-10 max-w-md">
          {t("login.subtitle")}
        </p>
        <Tabs defaultValue="email" className="w-full max-w-md">
          <TabsList className="mb-6">
            <TabsTrigger value="email" data-testid="login-tab-email">{t("login.tabEmail")}</TabsTrigger>
            <TabsTrigger value="google" data-testid="login-tab-google">Google</TabsTrigger>
          </TabsList>
          <TabsContent value="google">
        <Button size="lg" className="w-fit gap-2" onClick={handleGoogle} data-testid="google-login-button">
          <svg className="h-5 w-5" viewBox="0 0 24 24">
            <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z"/>
            <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="currentColor" d="M5.84 14.09a7.14 7.14 0 0 1 0-4.18V7.07H2.18a11 11 0 0 0 0 9.86l3.66-2.84z"/>
            <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          {t("login.google")}
        </Button>
          </TabsContent>
          <TabsContent value="email">
            <EmailAuth />
          </TabsContent>
        </Tabs>
        <div className="mt-8 flex gap-2">
          <Button variant="ghost" size="sm" data-testid="login-language-toggle" onClick={() => setLang(lang === "it" ? "en" : "it")}>
            {lang === "it" ? "English" : "Italiano"}
          </Button>
          <Button variant="ghost" size="sm" data-testid="login-theme-toggle" onClick={() => setTheme(theme === "dark" ? "light" : "dark")}>
            {theme === "dark" ? "Light" : "Dark"}
          </Button>
        </div>
      </div>
      <div className="hidden lg:block relative overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1664575602276-acd073f104c1?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="Accounting workspace"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent" />
      </div>
    </div>
  );
}
